import ReportLayout from './reportLayout.js';

export default ReportLayout;
